export default __webpack_public_path__ + "static/media/A4.ad14400e.png";